import React from 'react';
import styles from './logs.module.scss';
import convertDateTime from './convert';

export default function ActionRow({ item }) {
  const [show, setShow] = React.useState(false);

  return (
    <li className={styles.row}>
      <div className={styles.row__header}>
        <time className={styles.header__time} dateTime={item.timestamp}>
          {convertDateTime(item.timestamp)}
        </time>
        <span className={styles.header__tag}>{item.tag}</span>
        <span className={styles.header__message}>{item.message}</span>
        <div className={styles.row__divider} />
        {item.metadata && (
          <button
            onClick={() => setShow(!show)}
            className={styles.header__button}
          >
            <span>{show ? 'hide' : 'show'}</span>
          </button>
        )}
      </div>

      {show && item.metadata && (
        <div className={styles.row__content}>
          <pre className="language-js">
            <code>{JSON.stringify(item.metadata, null, '\t')}</code>
          </pre>
        </div>
      )}
    </li>
  );
}
